import React from "react";

import { customClasses } from "../../../Styles/customClasses";

import leftShape from "../../../Assets/right-square-shape.png";
//form
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormError, FormRadio } from "../../../Components/Basic";
import { LM } from "../../../Components/LM";

// schema
const schema = yup.object().shape({
  joint_divorce: yup.string().required("This is required").nullable(),

  ex_address_if_known: yup.string().when("joint_divorce", (joint_divorce) => {
    if (joint_divorce === "Myself")
      return yup.string().required("This is required").nullable();
  }),

  ex_address_if_overseas: yup
    .string()
    .when("joint_divorce", (joint_divorce) => {
      if (joint_divorce === "Myself")
        return yup.string().required("This is required").nullable();
    }),

  ex_if_post_respond: yup.string().when("joint_divorce", (joint_divorce) => {
    if (joint_divorce === "Myself")
      return yup.string().required("This is required").nullable();
  }),

  lived_apart_12m: yup.string().required("This is required").nullable(),
});

function UserQuest2({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });
  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className={customClasses.stepsWrapper}>
        <p className="text-2xl font-bold ">Final Questions</p>
        <div className="bg-nativeBlue-200 rounded-lg ">
          <p className="text-center text-white font-bold py-3 mt-10 mb-4	text-3xl ">
            Part 2 of 2
          </p>
        </div>

        <p className={customClasses.questionText}>
          Are you applying for a divorce jointly with your spouse or by
          yourself?
        </p>
        <LM>
          <p className={customClasses.helperText}>
            You can apply on your own or with your spouse.
          </p>

          <p className={customClasses.helperText}>
            If you’re applying jointly with your spouse, both you and your
            spouse will need to sign the divorce application form.{" "}
          </p>

          <p className={customClasses.helperText}>
            If you’re not sure, or your spouse has not agreed to sign, then
            select the applying by yourself option.
          </p>

          <p className={customClasses.helperText}>
            You can change this option later if your spouse agrees to sign.
          </p>
        </LM>

        <FormRadio
          register={register}
          name={"joint_divorce"}
          setValue={setValue}
          value="Myself"
        />
        <FormRadio
          register={register}
          name={"joint_divorce"}
          setValue={setValue}
          value="Joint"
        />
        <FormError error={errors.joint_divorce?.message} />

        {watch("joint_divorce") === "Myself" && (
          <>
            <p className={customClasses.questionText}>
              Do you know where your spouse currently lives?
            </p>

            <FormRadio
              register={register}
              name={"ex_address_if_known"}
              setValue={setValue}
              value="Yes"
            />
            <FormRadio
              register={register}
              name={"ex_address_if_known"}
              setValue={setValue}
              value="No"
            />
            <FormError error={errors.ex_address_if_known?.message} />
          </>
        )}

        {watch("joint_divorce") === "Myself" && (
          <>
            <p className={customClasses.questionText}>
              Does your spouse currently live overseas?
            </p>
            <FormRadio
              register={register}
              name={"ex_address_if_overseas"}
              setValue={setValue}
              value="Yes"
            />
            <FormRadio
              register={register}
              name={"ex_address_if_overseas"}
              setValue={setValue}
              value="No"
            />
            <FormRadio
              register={register}
              name={"ex_address_if_overseas"}
              setValue={setValue}
              value="Unsure"
            />
            <FormError error={errors.ex_address_if_overseas?.message} />
          </>
        )}

        {watch("joint_divorce") === "Myself" && (
          <>
            <p className={customClasses.questionText}>
              Will your spouse willingly sign, and send back, a form confirming
              they received the court documents?
            </p>
            <FormRadio
              register={register}
              name={"ex_if_post_respond"}
              setValue={setValue}
              value="Yes"
            />
            <FormRadio
              register={register}
              name={"ex_if_post_respond"}
              setValue={setValue}
              value="No"
            />
            <FormRadio
              register={register}
              name={"ex_if_post_respond"}
              setValue={setValue}
              value="Unsure"
            />
            <FormError error={errors.ex_if_post_respond?.message} />
          </>
        )}

        <p className={customClasses.questionText}>
          Did you and your spouse live apart in separate houses for at least 12
          months since you separated?
        </p>
        <FormRadio
          register={register}
          name={"lived_apart_12m"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"lived_apart_12m"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.lived_apart_12m?.message} />
      </section>

      <section>
        <img
          className="invisible md:visible w-1/6 absolute top-40 right-0 ml-10 "
          src={leftShape}
          alt="shape"
        />
      </section>
    </form>
  );
}

export default UserQuest2;
